"use client";

import Link from "next/link";
import type { MegaColumn } from "./types";
import { megaLinkProps } from "./data";

export function MorphChevron({ open }: { open: boolean }) {
  return (
    <span
      className="relative flex items-center justify-center"
      style={{ width: 12, height: 12 }}
      aria-hidden="true"
    >
      <span
        className="absolute block rounded-full bg-current"
        style={{
          width: "55%",
          height: 1.5,
          left: "2%",
          transformOrigin: "right center",
          transition: "transform 0.22s ease",
          transform: open ? "translateY(-1.5px) rotate(-40deg)" : "translateY(1.5px) rotate(40deg)",
        }}
      />
      <span
        className="absolute block rounded-full bg-current"
        style={{
          width: "55%",
          height: 1.5,
          right: "2%",
          transformOrigin: "left center",
          transition: "transform 0.22s ease",
          transform: open ? "translateY(-1.5px) rotate(40deg)" : "translateY(1.5px) rotate(-40deg)",
        }}
      />
    </span>
  );
}

export function MegaDropdown({ columns, onClose }: { columns: MegaColumn[]; onClose: () => void }) {
  return (
    <div className="absolute top-full left-0 z-50 pt-2" style={{ minWidth: 320 }}>
      <div className="bg-surface-1 border-foreground/8 overflow-hidden rounded-xl border shadow-2xl">
        <div className="flex gap-0 p-5">
          {columns.map((col, ci) => (
            <div
              key={col.items[0]?.label ?? col.items.map((it) => it.label).join("-")}
              className={`border-foreground/7 flex flex-col gap-4 ${columns.length === 1 ? "flex-1" : ""} ${ci > 0 ? "ml-5 border-l pl-5" : ""}`}
            >
              {col.items.map((item) => {
                if (item.static) {
                  return (
                    <span
                      key={item.label}
                      className="flex min-w-[140px] cursor-default items-center gap-2 select-none"
                    >
                      <span className="text-foreground/40 text-[14px] font-medium">
                        {item.label}
                      </span>
                      {item.chip && (
                        <span className="light:border-emerald-600/30 light:text-emerald-700 shrink-0 rounded-full border border-emerald-500/20 bg-emerald-500/10 px-1.5 py-0.5 text-[10px] leading-none font-semibold text-emerald-400">
                          {item.chip}
                        </span>
                      )}
                    </span>
                  );
                }

                return (
                  <Link
                    key={item.label}
                    href={item.href}
                    {...megaLinkProps(item)}
                    onClick={onClose}
                    className="group flex min-w-[140px] items-center gap-2"
                  >
                    <span className="text-foreground/75 group-hover:text-foreground text-[14px] font-medium transition-colors">
                      {item.label}
                    </span>
                    {item.chip && (
                      <span className="light:border-emerald-600/30 light:text-emerald-700 shrink-0 rounded-full border border-emerald-500/20 bg-emerald-500/10 px-1.5 py-0.5 text-[10px] leading-none font-semibold text-emerald-400">
                        {item.chip}
                      </span>
                    )}
                  </Link>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
